import { atom } from 'jotai';
import { InboxBrandResponse } from '@idk-web/api';
import { store } from '@/state/store';

export type InboxBrandState = {
  name: string | null;
  companyName: string | null;
  logoUrl: string | null;
  backgroundImage: string | null;
  primaryAccentColor: string | null;
  secondaryAccentColor: string | null;
  font: string | null;
  defaultLanguage: string | null;
  providers: InboxBrandResponse['providers'];
  languages: InboxBrandResponse['languages'];
};

const initialState: InboxBrandState = {
  name: null,
  companyName: null,
  logoUrl: null,
  backgroundImage: null,
  primaryAccentColor: null,
  secondaryAccentColor: null,
  font: null,
  defaultLanguage: null,
  providers: [],
  languages: [],
};

export const inboxBrandState = atom<InboxBrandState>(initialState);

export const inboxBrand = atom((get) => get(inboxBrandState));

export function setInboxBrandState(state: InboxBrandState): void {
  store.set(inboxBrandState, state);
}

export function updateBrand(brand: InboxBrandResponse): void {
  setInboxBrandState(brand);
}

export function resetBrand(): void {
  setInboxBrandState(initialState);
}

export default inboxBrandState;
